import { Typography } from '@material-ui/core'

export default Typography
